import SparkMD5 from "spark-md5";
import * as base64 from "byte-base64";

export async function FileMD5(file) {

  return new Promise((resolve, reject) => {
    var reader = new FileReader();

    reader.onload = function (event) {
      var binary = event.target.result;
      var md5 = SparkMD5.hashBinary(binary, false)
      resolve(md5);

    };

   if (file) {
    reader.readAsBinaryString(file);
   }
  });
}


